'use strict';

var api = {};

var dom = {};

var setupDom = function(){

	dom.document = $(document);
	dom.touchExperts = $(".touch .expert");

};

var addEventHandlers = function(){

	dom.touchExperts.click(function(){

		console.log('touchExperts clicked');

		$(this).toggleClass('expert--hover');

	});

	dom.document.on('click', '.item-overlay', function(){

		// $(this).parents('.expert').removeClass('expert--hover');

	});

};

api.init = function(){

	setupDom();

	addEventHandlers();

};

module.exports = api;